export default __webpack_public_path__ + "dd1fa3b91ed64c5c4b80f7777bfb7fe1.png";